import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ToasterService {
  defaultOptions = {
    closeButton: true,
    positionClass: "toast-bottom-right",
    timeOut: 0,
    extendedTimeOut: 1000,
    progressBar: true,
    preventDuplicates: true
  };

  constructor(
    private toastr: ToastrService
  ) {
  }

  public showToastWarning(title, message, options) {
    this.toastr.warning(message, title, options || this.defaultOptions);
  }

  public showToastSuccess(title, message, options) {
    this.toastr.success(message, title, options || this.defaultOptions);
  }

  public showToastInfo(title, message, options) {
    this.toastr.info(message, title, options || this.defaultOptions);
  }

  public showToastError(title, message, options) {
    this.toastr.error(message, title, options || this.defaultOptions);
  }

  public clear(toastId?: number){
    this.toastr.clear(toastId);
  }
}
